import React, { useState } from 'react';

import { Button, Variant } from '@indicia/component-library';

import SurveyAnswer from '../../../../shared/models/survey/SurveyAnswer';
import SurveyChoiceOption from '../../../../shared/models/survey/SurveyChoiceOption';
import { SurveyMultipleChoiceQuestionType } from '../SurveyQuestionTypes';

import '../SurveyQuestion.scss';

type PropType = SurveyMultipleChoiceQuestionType & {
  id: string;
  onAnswerSelect: (answer: SurveyAnswer) => void;
  options: SurveyChoiceOption[];
  bem: (element: string | null, modifier?: string | null, condition?: boolean) => string;
  previousAnswer: string[];
};

const SurveyIntroductionQuestion = ({ bem, id, options, onAnswerSelect, previousAnswer }: PropType) => {
  const [selectedAnswers, setSelectedAnswers] = useState<string[]>(previousAnswer || []);
  const handleClick = (optionId: string) => {
    const index = selectedAnswers.indexOf(optionId);
    let answers: string[] = [];
    if (index !== -1) {
      answers = [];
    } else {
      answers = [optionId];
    }

    setSelectedAnswers(answers);
    onAnswerSelect({
      value: answers,
      questionId: id,
    });
  };

  return (
    <div className={bem('answers')}>
      <div className={`${bem('multiple-choice')} ${bem('introduction')}`}>
        {options.map(({ description: label, id: optionId }) => (
          <Button
            key={optionId}
            variant={selectedAnswers.includes(optionId) ? Variant.Solid : Variant.Outlined}
            onClick={() => handleClick(optionId)}
          >
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SurveyIntroductionQuestion;
